import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { createTokenKey, selectToken } from '@caudena/web-platform'

export const TimelineWidgetWrapper = styled.div`
  display: flex;
  flex-flow: column;
  overflow: hidden;
  flex: 1;
  overflow-y: auto;
  ${({ theme }) => {
    return css({
      marginBottom: selectToken(theme, createTokenKey(['padding', 'xl'])),
    })
  }}
`
